import { List } from '../List'
import { CommonWork } from '../CommonWork'
import { BibliographyWorkParent } from '@/models'
import {
  checkDataCompleteness,
  getAuthors,
  getAuthorsPart,
  getDoi,
  getMagazineName,
  getMagazineNumber,
  getMainAuthor,
  getPages,
  getPartNumber,
  getPlaceInPublication,
  getPublicationEngName,
  getTome,
  getYear
} from '@/scripts/publicationFullBibliographicDescription'

export class PublicationParent extends List {
  constructor(obj) {
    super(Publication, obj)
  }
}

export class Publication {
  constructor(obj = {}) {
    this.id = obj?.id || null
    this.commonWork = new CommonWork(obj?.commonWork || null)
    this.partNumber = obj?.partNumber || null
    this.magazineNumber = obj?.magazineNumber || null
    this.page = obj?.page || null
    this.doi = obj?.doi || null
    this.tome = obj?.tome || null
    this.articleEng = obj?.articleEng || null
    this.isForeign = obj?.isForeign || false
    this.magazine = obj?.magazine || null
    this.magazineName = obj?.magazineName || null
    this.isForeignPeriodMagazine = obj?.isForeignPeriodMagazine || false
    this.publicationEngName = obj?.publicationEngName || null
    this.conferenceMaterial = obj?.conferenceMaterial || Boolean(obj?.magazineName) || false
    this.publicationForm = obj?.publicationForm || null
    this.isVac = obj?.isVac || false
    this.isWhiteList = obj?.isWhiteList || false
    this.pageFrom = obj?.pageFrom ? obj?.pageFrom : null
    this.pageTo = obj?.pageTo ? obj?.pageTo : null
    this.electronicNumber = obj?.electronicNumber || null
    this.bibliographyWorks = new BibliographyWorkParent().buildFromAPI(obj?.bibliographyWorks)
    this.citationCount = obj?.citationCount || null
    this.publishingYear = obj?.publishingYear || null
    this.catalog = obj?.catalog || null
    this.whiteListLevel = obj?.whiteListLevel || null
  }

  get publicationOutput() {
    return `${this.tome ? 'Том № ' + this.tome + ', ' : ''}${
      this.partNumber ? 'Часть № ' + this.partNumber + ', ' : ''
    }${this.magazineNumber ? 'Журнал № ' + this.magazineNumber + ', ' : ''}${this.pageFrom} - ${this.pageTo} с.`
  }

  get fullBibliographicDescription() {
    if (!this.commonWork.authors.list.length) return null
    const mainAuthor = getMainAuthor(this)
    const authors = getAuthors(this)

    return checkDataCompleteness(this, authors)
      ? `${getAuthorsPart(this, mainAuthor, authors)} // ${getMagazineName(this)}, ${getYear(
          this
        )}.${getPublicationEngName(this)}${getMagazineNumber(this)}${getTome(this)}${getPartNumber(
          this
        )} — ${getPlaceInPublication(this)}. ${getDoi(this)}`
      : null
  }

  getForAPI() {
    return {
      id: this.id,
      commonWork: this.commonWork.getForAPI(),
      partNumber: this.partNumber,
      magazineNumber: this.magazineNumber,
      pageFrom: this.pageFrom,
      pageTo: this.pageTo,
      electronicNumber: this.electronicNumber,
      publicationOutput: this.publicationOutput,
      fullBibliographicDescription: this.fullBibliographicDescription,
      doi: this.doi,
      tome: this.tome,
      articleEng: this.articleEng,
      isForeign: this.isForeign,
      magazine: this.magazine,
      magazineName: this.magazineName,
      isForeignPeriodMagazine: this.isForeignPeriodMagazine,
      publicationEngName: this.publicationEngName,
      conferenceMaterial: this.conferenceMaterial,
      publicationForm: this.publicationForm,
      isVac: this.isVac,
      isWhiteList: this.isWhiteList,
      bibliographyWorks: this.bibliographyWorks.getForAPI(this.isVac),
      citationCount: this.citationCount,
      publishingYear: this.publishingYear,
      catalog: this.catalog,
      whiteListLevel: this.whiteListLevel
    }
  }
}
